import React from 'react';
import styled from 'styled-components';


// import {LAYOUT_XS, LAYOUT_SM} from './../../settings';

// import Icon from "./../App/Icon";
// import Button from "./../App/Button";

const Wrapper  = styled.div.withConfig({displayName:'-Wrapper '})`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: #1e1e1eE6;
  z-index: 999999;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #000000;
`;
const Content  = styled.div.withConfig({displayName:'-Content '})`
  position: relative;
  width: calc(100vw - 88px);
  height: calc(100vh - 88px);
  // background: #ffffff;

  overflow: hidden;
`;
const Close  = styled.div.withConfig({displayName:'-Close '})`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 44px;
  height: 44px;
  background-color: #000000;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;


const FullModal = ({
  variant = "default",
  onClose = () => {},
  children
}) => {

  return (
    <Wrapper>
      <Close onClick={() => onClose()}>
        <i className="fa-solid fa-x"></i>
      </Close>
      <Content>
        {children}
      </Content>
    </Wrapper>
  )
}
export default FullModal;
